import { render, staticRenderFns } from "./SalesClientsLineChart.vue?vue&type=template&id=fd87dadc&scoped=true"
import script from "./SalesClientsLineChart.vue?vue&type=script&lang=js"
export * from "./SalesClientsLineChart.vue?vue&type=script&lang=js"
import style0 from "./SalesClientsLineChart.vue?vue&type=style&index=0&id=fd87dadc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd87dadc",
  null
  
)

export default component.exports